import React from 'react';

type Props = {
  value?: React.CSSProperties['color'];
} & React.InputHTMLAttributes<HTMLInputElement>;

const Color = ({ value = '', ...rest }: Props) => <input type="color" value={value} {...rest} />;

export default Color;
